const isPaidUser = (membership) => {
  if (membership === 'annual' || membership === 'monthly') {
    return true
  }
  return false
}

export default isPaidUser
